import { CategoryWithId } from "../interfaces/ICategories";
import { findCategoriesByQuery, OrderByCondition, WhereCondition } from "../utils/firestore";
import { useEffect, useMemo, useState } from "react";

export const useContestCategories = (contestId: string) => {
  const [categories, setCategories] = useState<CategoryWithId[]>([]);

  // Memoizacja whereConditions i orderConditions aby uniknąć problemów z wydajnością
  const whereConditions: WhereCondition[] = useMemo(
    () => [
      { field: "contestId", operator: "==", value: contestId },
      { field: "isActive", operator: "==", value: true },
      { field: "inModeration", operator: "==", value: false },
    ],
    [contestId]
  );

  const orderConditions: OrderByCondition[] = useMemo(() => [], []);

  useEffect(() => {
    if (contestId) {
      findCategoriesByQuery(
        "contests/" + contestId + "/categories",
        whereConditions,
        orderConditions
      ).then((data: CategoryWithId[]) => {
        setCategories(data);
      });
    }
  }, [contestId, whereConditions, orderConditions]);

  return { categories };
};
